export default "__VITE_ASSET__Cr6tqERV__"